// extracted by mini-css-extract-plugin
export default {"app":"t1YWug","scrollable":"qHpbsu","baseStyles":"sXdULV","mobileBaseStyles":"b79EPn"};